module.exports = __webpack_public_path__ + "static/media/xiaoyu.b94b8a80.png";